import type { ReactNode } from 'react';

export type OverviewInfoLink = {
  icon?: string;
  label: string;
  node?: ReactNode;
};

export const buildOverviewInfoLinks = (
  workflowName: string | undefined
): OverviewInfoLink[] => [
  { icon: 'TableColumns', label: workflowName ?? 'Workflow' }
];
